export const schoolDataConstants = {
	orgs: [
		{
			schoolId: "00000000000",
			name: ["教育局", "EDUCATION BUREAU"],
		},
	],
	specialSchoolId: "00000000000",
};
